import { render, staticRenderFns } from "./MultiRowsBlockList.vue?vue&type=template&id=5257f993"
import script from "./MultiRowsBlockList.vue?vue&type=script&lang=ts"
export * from "./MultiRowsBlockList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports